module.exports = __webpack_public_path__ + "media/images/client/mic_off_icon-30b3acb7f895e641d289c91631a69120.png";